import { gql, useQuery } from '@apollo/client'

import {
  ConsoleItemInformationLimitUserQuery,
  ConsoleItemInformationLimitUserQueryVariables,
  PurchasableUserDetailFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()

  const { router } = useRouter<{ itemId: string }>()

  const { data, loading } = useQuery<
    ConsoleItemInformationLimitUserQuery,
    ConsoleItemInformationLimitUserQueryVariables
  >(QUERY, { variables: { id: router.query.itemId } })

  return {
    state: {
      loading,
      purchasableUsers: data?.item?.purchasableUsers ?? null,
      artistId: user?.uid ?? '',
      hasNextPage: false,
    },
    actions: {
      async onFetchMore() {},
    },
  }
})

const QUERY = gql`
  query ConsoleItemInformationLimitUser($id: ID!) {
    item(id: $id) {
      id
      purchasableUsers {
        ...PurchasableUserDetail
      }
    }
  }
  ${PurchasableUserDetailFragmentDoc}
`
